import type { AgentApiCandidateFormsShow } from '@/types/serializers';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface ReorderCandidateFormItemsParams {
  ids: number[];
}

/**
 * candidate_form_itemsの順序変更用のフック
 */
export default function useReorderCandidateFormItems() {
  const queryClient = useQueryClient();
  const token =
    (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)?.content || '';

  return useMutation({
    mutationFn: async (params: ReorderCandidateFormItemsParams) => {
      const response = await fetch('/agent/api/candidate_forms/candidate_form_items/reorder', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        credentials: 'same-origin',
        body: JSON.stringify({ ids: params.ids }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || '並び順の更新に失敗しました');
      }

      const data: AgentApiCandidateFormsShow = await response.json();
      return data;
    },
    onSuccess: (data) => {
      // サーバーから返されたデータでキャッシュを直接更新
      queryClient.setQueryData<AgentApiCandidateFormsShow>(['candidate_forms'], data);
      // キャッシュを無効化して、useFetchCandidateFormを使っているコンポーネントを再フェッチさせる
      // これにより、propsで渡されたcandidateFormも更新される
      queryClient.invalidateQueries({ queryKey: ['candidate_forms'] });
    },
  });
}
